import {
  Button,
  Form,
  Input,
  InputNumber,
  Select,
  Switch,
  Tooltip,
  Slider,
  Drawer,
} from "ant-design-vue";

export default function (app) {
  app.use(Button);
  app.use(Form);
  app.use(Input);
  app.use(InputNumber);
  app.use(Select);
  app.use(Switch);
  app.use(Tooltip);
  app.use(Slider);
  app.use(Drawer);
}
